module.exports = "/_next/static/images/website-webapp-banner-d1e9fc5fb9339dfcd8ca54d33777efec.webp";